
import enTrans from '../locales/en/translation.json';
import viTrans from '../locales/vi/translation.json';
// Antd locale files

export const LOCALIZATIONS = {
  vi: 'vi',
  en: 'en',
};

export const RESOURCES = {
  [LOCALIZATIONS.vi]: { translation: viTrans },
  [LOCALIZATIONS.en]: { translation: enTrans },
};

export const REGIONS = {
  [LOCALIZATIONS.vi]: {
    key: LOCALIZATIONS.vi,
    name: 'Tiếng Việt',
  },
  [LOCALIZATIONS.en]: {
    key: LOCALIZATIONS.en,
    name: 'English',
  },
};

export const LANG = 'lang';
